import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { ControlValueAccessor, NgControl, ValidationErrors } from '@angular/forms';
import { Component, EventEmitter, Input, Optional, Output, Self, ViewEncapsulation } from '@angular/core';

// interfaces
import { Ivalidation } from 'src/app/core/interfaces/form/validation';

// helpers
import { chainKeyForValue } from 'src/app/core/funcations-helper/helpers';

@Component({
  standalone: true,
  selector: 'app-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ NgIf, NgFor, NgTemplateOutlet ]
})
export class CheckBoxComponent implements ControlValueAccessor {

  /**
   * Inputs
   */
  
  /**
   * @description that value will back i input is checked
   */
  @Input({ alias: 'value' }) public value: any = null

  /**
   * @description that default value will return if ( prop value not defined )
   * if that prop not defined & ( prop value not defined ) then will return checked status ( true, false )
   */
  @Input({ alias: 'defaultReturnValue' }) public DefaultReturnValue: any = null  

  /**
   * 
   */
  @Input({ alias: 'label' }) public label: string = null

  /**
   * 
   */
  @Input({ alias: 'validations' }) validations: Ivalidation[] = []

  /**
   * 
   */
  @Input({ alias: 'name', required: true }) public Name: string = null;

  /**
   * 
   */
  @Input({ alias: 'markAsRequired' }) public MarkAsRequired: boolean = false

  /**
   * 
   */
  @Input({ alias: 'validatorsErrorMsg' }) public validatorsErrorMsg: boolean = true;

  /**
   * 
   */
  @Input({ alias: 'disabledLineThrough' }) public DisabledLineThrough: boolean = true

  /**
   * Output
   */
  @Output() Change = new EventEmitter();
  
  /**
   * fields
   */
  public touched = false;
  public disabled = false;

  constructor(@Self() @Optional() public ngControl: NgControl) {
    /**
     * 
     */
    if (this.ngControl) {
      this.ngControl.valueAccessor = this
    }    

  }

  ngOnInit(): void {}

  /**
   * 
   * @param value 
   */
  public onChange = (value) => {};

  /**
   * 
   */
  public onTouched = () => {};   

  writeValue(value: string) {
    // this.value = value
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  /**
   * 
   * @param event input event
   * @description with fire event that input will be touched,
   * if input not disabled that will fire onChange control & emit ChangeEventEmitter
   * @returns if ( prop value & DefaultReturnValue not defined ) then will return checked status ( true, false )
   * else, with checked ( true ) return ( prop value ), false return ( prop DefaultReturnValue )
   */
  change(event: Event) {

    // ES6 Destruction
    const { checked } = event.target as HTMLInputElement;

    /**
     * 
     */
    this.markAsTouched();
    
    /**
     * 
     */
    if (!this.disabled) {

      /**
       * 
       */
      let returnedValue = null;

      /**
       * handler to return value or check status or default value with false check
       */
      if (this.value != null) returnedValue = checked ? this.value : (this.DefaultReturnValue ? this.DefaultReturnValue : null);
      else returnedValue = this.DefaultReturnValue ? this.DefaultReturnValue : checked;

      /**
       * 
       */
      this.onChange(returnedValue);
      
      /**
       * 
       */
      this.Change.emit(returnedValue);


    }

  }
  
  // getters

  get control() {
    return this.ngControl?.control
  }
    
  /**
   * 
   */
  private get Errors(): ValidationErrors | null {
    
    return this.ngControl?.errors

  }

  /**
   * 
   */
  public get ErrorMsg() {

    return this.validatorsErrorMsg ? chainKeyForValue(this.Errors) : null;

  }

}
